import { render } from "./ContentPreviewPane.vue?vue&type=template&id=01a4ecc0&scoped=true"
import script from "./ContentPreviewPane.vue?vue&type=script&lang=js"
export * from "./ContentPreviewPane.vue?vue&type=script&lang=js"

import "./ContentPreviewPane.vue?vue&type=style&index=0&id=01a4ecc0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a4ecc0"]])

export default __exports__